import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    email: String,
    authenticated: { type: Boolean, default: false },
    emailSelector: String,
  };

  connect() {
    if (this.emailValue) {
      this.#identify(this.emailValue);
    }
  }

  identify() {
    const field = this.element.querySelector(this.emailSelectorValue);
    if (field?.value) {
      this.#identify(field.value);
    }
  }

  #identify(email) {
    window.posthog?.identify(email, {
      email,
      authenticated: this.authenticatedValue,
    });
  }
}
